import { render } from "./QuerySection.vue?vue&type=template&id=e0d99428&scoped=true"
import script from "./QuerySection.vue?vue&type=script&lang=js"
export * from "./QuerySection.vue?vue&type=script&lang=js"

import "./QuerySection.vue?vue&type=style&index=0&id=e0d99428&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0d99428"]])

export default __exports__